// Build-time configuration, inlined by Create React App from REACT_APP_* env
// vars (set by the deploy workflow from the CDK stack outputs). All values are
// public — the Cognito app client has no secret, and the blog API's write
// routes are guarded server-side by the JWT authorizer.

export const BLOG_API_URL = (process.env.REACT_APP_BLOG_API_URL ?? '').replace(/\/$/, '');

export const COGNITO = {
  region: process.env.REACT_APP_AWS_REGION ?? 'us-east-1',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID ?? '',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
};

/** True when the blog backend URL is configured (i.e. a real build, not a bare dev run). */
export const isBlogConfigured = (): boolean => BLOG_API_URL.length > 0;

/** True when Cognito is configured for the admin editor. */
export const isAdminConfigured = (): boolean =>
  COGNITO.userPoolId.length > 0 && COGNITO.clientId.length > 0;

/**
 * Local-only escape hatch: when `REACT_APP_ADMIN_BYPASS_AUTH=true`, the admin
 * area skips Cognito sign-in so the UI can be exercised against a mock API.
 * The deploy workflow never sets this, so production is always guarded — and
 * it's inert in a `production` build regardless, as a belt-and-suspenders.
 */
export const bypassAdminAuth = (): boolean =>
  process.env.NODE_ENV !== 'production' && process.env.REACT_APP_ADMIN_BYPASS_AUTH === 'true';
